import { Icon, IconProps } from '@chakra-ui/react'

export function EnvelopeIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 18 14" fill="none" {...props}>
      <path
        d="M17.3334 0.333252H0.67502L0.666687 13.6666H17.3334V0.333252ZM15.6667 11.9999H2.33335V3.66658L9.00002 7.83325L15.6667 3.66658V11.9999ZM9.00002 6.16658L2.33335 1.99992H15.6667L9.00002 6.16658Z"
        fill="currentColor"
      />
    </Icon>
  )
}
